export { FaviconTags } from './components/FaviconTags'
export { getAssetDefaults, setDynamicFavicon } from './lib/util'
export * from '../types'
